import { Typography } from "antd";
import { RiMoneyDollarCircleLine, RiFileSearchLine, RiHandCoinLine } from "react-icons/ri";

export const cards = [
  {
    id: "anual-report",
    type: ['bolsa', 'exterior'],
    icon: (
      <RiFileSearchLine
        size={24}
        className="no-fill"
        color="var(--ant-primary-color)"
      />
    ),
    content: <Typography>RELATÓRIOS ANUAIS</Typography>,
    description: (
      <Typography>
        Relatórios auxiliares para preenchimento da DIRPF
      </Typography>
    ),
  },
  {
    id: "gain",
    type: ['bolsa', 'exterior'],
    icon: (
      <RiMoneyDollarCircleLine
        size={24}
        className="no-fill"
        color="var(--ant-primary-color)"
      />
    ),
    content: <Typography>INFORMES DE GANHO DE CAPITAL</Typography>,
    description: (
      <Typography>
        Relatórios auxiliares para acompanhamento do ganho de capital (GCAP)
      </Typography>
    ),
  },
  {
    id: "income",
    type: ['exterior'],
    icon: (
      <RiHandCoinLine
        size={24}
        className="no-fill"
        color="var(--ant-primary-color)"
      />
    ),
    content: <Typography>INFORMES DE DIVIDENDOS</Typography>,
    description: (
      <Typography>
        Relatórios auxiliares para acompanhamento dos dividendos recebidos no
        exterior (carnê-leão)
      </Typography>
    ),
  },
];
